import { BookIndex, BookChapter, ChapterInfo } from '../types/book';
import { getUserId } from '../utils/userId';

const API_BASE_URL = '/api';

/**
 * API 호출에 필요한 헤더를 생성합니다.
 */
const getHeaders = (): HeadersInit => {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };

  const userId = getUserId();
  if (userId) {
    headers['X-USER-ID'] = userId;
  }

  return headers;
};

export class BookApiService {
  /**
   * Book 인덱스 데이터를 조회합니다.
   */
  static async getBookIndices(): Promise<BookIndex[]> {
    const response = await fetch(`${API_BASE_URL}/book/indices`, {
      headers: getHeaders()
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  }

  /**
   * 특정 Book의 장(chapter)의 모든 절(verse)을 조회합니다.
   */
  static async getBookChapter(
    bookNo: number, 
    chapter: number
  ): Promise<BookChapter> {
    try {
      const response = await fetch(`${API_BASE_URL}/book/${bookNo}/${chapter}`, {
        headers: getHeaders()
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const verses = await response.json();
      // API 응답이 배열 형태로 직접 절들을 반환하므로 이를 처리
      return {
        version: 'default',
        bookNo,
        bookName: '', // 이 정보는 별도로 가져와야 함
        chapter,
        verses: verses
      };
    } catch (error) {
      console.error('Book 장 조회 중 오류가 발생했습니다:', error);
      throw error;
    }
  }

  /**
   * 특정 Book의 챕터 리스트를 조회합니다.
   */
  static async getBookChapters(bookNo: number): Promise<ChapterInfo[]> {
    try {
      const response = await fetch(`${API_BASE_URL}/book/${bookNo}`, {
        headers: getHeaders()
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data || [];
    } catch (error) {
      console.error('Book 챕터 리스트 조회 중 오류가 발생했습니다:', error);
      return [];
    }
  }
}
